import { combineReducers } from "redux";

import authReducer from "./AuthReducer";

// CUSTOMER
import addressReducer from "./AddressReducer";
import virtualLockerReducer from "./VirtualLockerReducer";
import orderReducer from "./OrderReducer";

// ADMIN
import customerReducer from "./admin/customer-reducer";
import shopperReducer from "./admin/shopper-reducer";
import productReducer from "./admin/product-reducer";
import lockerReducer from "./admin/locker-reducer";
import orderDataReducer from "./admin/order-reducer";
import settingDataReducer from "./admin/setting-reducer";
import roleReducer from "./admin/role-reducer";
import personalShopperReducer from "./PersonalShopperReducer";
import groupCartReducer from "./group-cart-reducer";
import invitationsReducer from "./InvtitaionsReducer";

const rootReducer = combineReducers({

  auth: authReducer,

  //CUSTOMER
  address: addressReducer,
  virtual: virtualLockerReducer,
  order: orderReducer,
  invitations: invitationsReducer,
  
  //ADMIN
  customer: customerReducer,
  shopper: shopperReducer,
  product: productReducer,
  locker: lockerReducer,
  orderData: orderDataReducer,
  settingData: settingDataReducer,
  roleData: roleReducer,

  //PERSONAL SHOPPER
  persionalShopData: personalShopperReducer,
  groupCartData: groupCartReducer,
});

export default rootReducer;
